<template>
  <marketing-automation-form-panel-section class="marketing-automation-form-panel-section-repeat"
                                           :title="$t('message.automation.message.setRepetition')">
    <checkbox class="marketing-automation-form-panel-section-repeat-item"
              v-model="internal.dontRepeat"
              :label="$t('message.automation.message.doNotRepeat')"
              :text="$t('message.automation.message.doNotRepeatHint')"
              bold
              @input="setIsRepeat('dontRepeat', false)" />

    <checkbox class="marketing-automation-form-panel-section-repeat-item"
              v-model="internal.repeat"
              :label="$t('message.automation.message.repeat')"
              :text="$t('message.automation.message.repeatHint')"
              bold
              @input="setIsRepeat('repeat', true)" />

    <checkbox class="marketing-automation-form-panel-section-repeat-item"
              v-model="internal.repeatByDays"
              v-if="isStartByAccessType || isStartByPeriodWithoutAccessType"
              :hide-details="true"
              :label="$t('message.automation.message.repeatInterval')"
              :text="$t('message.automation.message.repeatIntervalHint')"
              bold
              @input="setIsRepeat('repeatByDays', true)" />

    <div v-if="internal.repeatByDays"
         class="marketing-automation-form-panel-entry-section-counter-item">
      <p class="marketing-automation-form-panel-entry-section-counter-item-text">{{$t('message.automation.message.repeatEvery')}}</p>
      <text-field class="marketing-automation-form-panel-entry-section-counter-item-inpt"
                  :value="value.periodToRepeat"
                  :min="0"
                  name="Intervalo de dias"
                  type="number"
                  validate="required"
                  @input="emitInput('periodToRepeat', $event)"></text-field>
      <p class="marketing-automation-form-panel-entry-section-counter-item-text">{{$t('message.automation.message.days')}}</p>
    </div>
  </marketing-automation-form-panel-section>
</template>

<script>
import TextField from "@components/form/TextField.vue";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";
import Checkbox from "@components/Checkbox";
import { cloneDeep } from "lodash";

export default {
  components: {
    Checkbox,
    MarketingAutomationFormPanelSection,
    TextField,
  },

  props: {
    type: {
      type: String,
    },
    value: {
      type: Object,
      default() {
        return {
          periodToRepeat: undefined,
          isRepeat: undefined,
        };
      },
    },
  },

  created() {
    this.setInitialData();
  },

  computed: {
    selectTypeTitle() {
      return this.type
        ? this.stepTypeOptions.find(
            (option) => option.id === this.form.stepType
          ).label
        : this.$t('message.automation.message.select');
    },
    isBirthdayType() {
      return this.type === "START_BY_BIRTHDATE";
    },
    isStartByAccessType() {
      return this.type === "START_BY_ACCESS";
    },
    isStartByPeriodWithoutAccessType() {
      return this.type === "START_BY_PERIOD_WITHOUT_ACCESS";
    },
  },

  data() {
    return {
      internal: {
        dontRepeat: false,
        repeat: false,
        repeatByDays: false,
      },
      stepTypeOptions: [
        {
          id: "START_BY_ACCESS",
          label: this.$t('message.automation.message.accessMade'),
        },
        {
          id: "START_BY_PERIOD_WITHOUT_ACCESS",
          label: this.$t('message.automation.message.periodWithoutAccess'),
        },
        {
          id: "START_BY_ACCESS_COUNT",
          label: this.$t('message.automation.message.numberOfAccesses'),
        },
        {
          id: "START_BY_BIRTHDATE",
          label: this.$t('message.automation.message.birthday'),
        },
      ],
    };
  },

  methods: {
    setErrorMessage(message) {
      console.log(message);
    },
    setInitialData() {
      if (this.value.periodToRepeat) {
        this.internal.repeatByDays = true;
      } else if (this.value.isRepeat) {
        this.internal.repeat = true;
      } else {
        this.internal.dontRepeat = true;
      }
    },
    setIsRepeat(internalKey, value) {
      if (internalKey === "dontRepeat") {
        this.internal.repeat = false;
        this.internal.repeatByDays = false;
      } else if (internalKey === "repeat") {
        this.internal.dontRepeat = false;
        this.internal.repeatByDays = false;
      } else if (internalKey === "repeatByDays") {
        this.internal.repeat = false;
        this.internal.dontRepeat = false;
      }

      if (internalKey !== "repeatByDays") {
        this.$nextTick(() => {
          this.emitInput("periodToRepeat", null);
        });
      }

      this.emitInput("isRepeat", value);
    },
    emitInput(key, val) {
      const value = cloneDeep(this.value);

      value[key] = val;

      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-panel-section-repeat {
  .marketing-automation-form-panel-section-repeat-item {
    ::v-deep .checkbox-label-text {
      font-size: 15px;
      color: #3b3b3b;
    }
  }

  .marketing-automation-form-panel-entry-section-counter-item {
    position: relative;
    font-weight: 600;
    color: #707070;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;

    .marketing-automation-form-panel-entry-section-counter-item-text {
      &:first-child {
        margin-right: 55px;
      }
    }

    .marketing-automation-form-panel-entry-section-counter-item-inpt {
      position: absolute;
      right: 67px;
      top: -12px;
      padding: 0 !important;
      margin: 0 7px !important;

      ::v-deep .text-field-body {
        width: 25px;
        margin-left: auto;
      }

      ::v-deep input {
        text-align: center;
        color: #707070;
      }

      ::v-deep .text-field-text {
        font-size: 10px;
        width: 143%;
        text-align: center;
      }
    }
  }
}
</style>
